import { experiments as r } from "./index.js";
function n(i) {
  let t = r.getVariant(i);
  return t || (t = r.coinflip(i), r.setVariant(i, t)), t;
}
export {
  n as u
};
